import * as R from 'ramda'
import {ArticleTemplateId, Layout, maxPrioritiesFromLayout} from "./data";
import {Action} from "redux";
import {isListAction, ListAction} from "./actions";
import {findInObj, objToList, reduceToObj} from "../../../lib/utils";
import {ArticleTemplate, ArticleTemplateFromPHP, Column, Priority, sortByColumnAndPriority, toColumn} from "../data";


export type State = {
	layout: Layout
	selected: ArticleTemplateId[]
	toolbar: ToolbarState
}

export type ToolbarState = {
	canEdit: boolean
	canMulti: boolean
}

export const reducer = (s: State, a: Action): State => {
	if(isListAction(a)) {
		return listReducer(s, a.action)
	}

	return s
}

const listReducer = (s: State, a: ListAction): State => {
	switch (a.type) {
		case "select all article templates":
			const s1 = objToList((a:ArticleTemplate) => a.id, s.layout)
			return {...s, selected: s1, toolbar: toolbarState(s1)}
		case "unselect all article templates":
			const s2:ArticleTemplateId[] = []
			return {...s, selected: s2, toolbar: toolbarState(s2)}
		case "select article template":
			const s3 = [a.id].concat(s.selected)
			return {...s, selected: s3, toolbar: toolbarState(s3)}
		case "unselect article template":
			const s4 = s.selected.filter(id => id != a.id)
			return {...s, selected: s4, toolbar: toolbarState(s4)}
		case "change column":
			let p = 1
			const oldColumn = s.layout[a.id].column
			return {
				...s,
				layout: reduceToObj(
					(articleTemplate: ArticleTemplate) => articleTemplate.id,
					(articleTemplate: ArticleTemplate) => {
						const x:ArticleTemplate = {...articleTemplate}
						if(articleTemplate.id === a.id) {
							x['column'] = a.column
							x['priority'] = maxPrioritiesFromLayout(s.layout)[a.column]+1
						} else if (articleTemplate.column === oldColumn) {
							x['priority'] = p++
						}
						return x
					},
					objToList((a: ArticleTemplate) => a, s.layout).sort(sortByColumnAndPriority)
				)
			}
		case "change priority":
			const article1 = s.layout[a.id]
			const article2 = findArticleInColumnWithPriority(s.layout, article1.column, a.priority)
			const article2New = article2 !== undefined
				? {[article2.id]: {...article2, priority: article1.priority}}
				: {}
			return {
				...s,
				layout: {
					...s.layout,
					...article2New,
					[article1.id]: {...article1, priority: a.priority}
				}
			}
		case "add copied article templates":
			const newLayout = {...s.layout}
			a.copiedArticleTemplates.forEach((a:ArticleTemplateFromPHP) => {
				const id = a.id.toString()
				newLayout[id] = {
					id: id,
					title: a.title,
					column: toColumn(a.column),
					priority: a.priority
				}
			})
			return {...s, layout: newLayout}
		case "delete article templates":
			const s5 = s.selected.filter((id:ArticleTemplateId) => {
				return !R.contains(id, a.deletedArticleTemplateIds)
			})
			return {
				...s,
				selected: s5,
				layout: R.omit(a.deletedArticleTemplateIds, s.layout),
				toolbar: toolbarState(s5)
			}
	}
}

export const findArticleInColumnWithPriority = (layout: Layout, column: Column, priority: Priority) => {
	return findInObj((a: ArticleTemplate) => a.column === column && a.priority === priority, layout)
}

const toolbarState = (selected: ArticleTemplateId[]): ToolbarState => {
	return {
		canEdit: selected.length === 1,
		canMulti: selected.length >= 1
	}
}



// WEBPACK FOOTER //
// ./src/communications/article-templates/writable/reducers.ts